<template>
    <div class="sa-list-component">
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header stacked="lg" striped hover :currentPage="currentPage" :items="items"
                    :fields="fields" sort-icon-left head-variant="light" class="sa-b-table" select-mode="single"
                    current-page="1" :per-page="perPage">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(scaduto)="row">
                        <div v-if="row.item.scaduto">❌</div>
                        <div v-else>✅️</div>

                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button size="sm" v-b-tooltip.hover title="Visualizza Listino" variant="outline-secondary"
                                class="mr-1 no-text" @click="onClickViewLsitinoMagazzino(row.item)">
                                <font-awesome-icon icon="eye" />
                            </b-button>
                            <b-button size="sm" v-b-tooltip.hover class="mr-1 no-text" title="Modifica Listino"
                                variant="outline-success" @click="onClickModificaLsitinoMagazzino(row.item)">
                                <font-awesome-icon icon="edit" />
                            </b-button>
                            <b-button size="sm" v-b-tooltip.hover class="mr-1 no-text" title="Rimuovi Listino"
                                variant="outline-danger" @click="onClickRimuoviLsitinoMagazzino(row.item)">
                                <font-awesome-icon icon="trash" />
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
                <!-- <magazzino-listini-edit-modal-component ref="cmpMagazzinoListiniEditModal"
                    @afterSave="onAfterSave"></magazzino-listini-edit-modal-component> -->
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
// import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";



export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    components: {

    },

    data() {
        return {
            pathResource: "/magazzinoarticoli/scadenze",
            rows: 0,
            perPage: 50,
            currentPage: 1,
            items: [],
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Articolo",
                    key: "nomeArticolo",
                },
                {
                    label: "Lotto Matricola",
                    key: "lottoMatricola",
                },
                {
                    label: "Giacenza Articolo",
                    key: "giacenze",
                },
                {
                    label: "Giacenza Base Lotto",
                    key: "giacenzaBase",
                },
                {
                    label: "Giacenza Formato Lotto",
                    key: "giacenzaFormato",
                },
                {
                    label: "Info Scadenza",
                    key: "scadenza",
                },

                {
                    label: "Scaduto",
                    key: "scaduto",
                },

            ]
        };
    },
    mounted() { },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {

        loadData(filtroScadenzaCodiciLotto) {
            this.$emit("beforeLoadData");

            let filtro = filtroScadenzaCodiciLotto;
            this.openShowModalLoading();

            filtro = { ...filtro }

            UtilityMixin.methods.loadDataResources(this.pathResource, filtro, this.loadDataSuccess, this.loadDataError);
        },
        loadDataSuccess(response) {
            this.items = response.data.data;
            this.rows = this.items.length;
            this.closeShowModalLoading();
        },
        loadDataError(error) {
            console.log(error);
            this.closeShowModalLoading();
        },


        // onRowSelectedArticoliItems() { },
        // onClickModificaLsitinoMagazzino(item) {
        //     this.$refs.cmpMagazzinoListiniEditModal.show(item.id);
        // },
        // onClickRimuoviLsitinoMagazzino(item) {
        //     let me = this;
        //     this.$bvModal
        //         .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
        //             title: "Eliminazione Listino",
        //             buttonSize: "sm",
        //             okVariant: "secondary",
        //             cancelVariant: "danger",
        //             okTitle: "SI",
        //             cancelTitle: "NO",
        //             footerClass: "p-2",
        //             hideHeaderClose: false,
        //             centered: true,
        //         })
        //         .then((value) => {
        //             if (value) {
        //                 me.rimuoviLsitinoMagazzino(item.id);
        //             }
        //         })
        //         .catch((err) => {
        //             console.log(err);
        //         });
        // },
        // rimuoviLsitinoMagazzino(id) {
        //     let me = this;
        //     me.showModalLoading = true;
        //     let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
        //     axios
        //         .delete(link)
        //         .then((Response) => {
        //             console.log(Response);
        //             me.showModalLoading = false;
        //             me.loadDataMagazzinoListini();
        //         })
        //         .catch((e) => {
        //             console.log(e);
        //         });
        // },
        // onAfterSave() {
        //     this.loadDataMagazzinoListini();
        // },
        // nuovoMagazzinoListino() {
        //     this.$refs.cmpMagazzinoListiniEditModal.show();
        // },
    },
};
</script>

<style></style>
